import { black, white } from '../utilities/color-constants.js';
/**
 * @internal
 */
export function foregroundOnErrorAlgorithm(reference, contrastTarget) {
    return reference.contrast(white) >= contrastTarget ? white : black;
}
